'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var react = require('react');

var useClickawayListener = function useClickawayListener(ref, cb) {
  react.useEffect(function () {
    var containsTarget = function containsTarget(e, r) {
      return r.current && r.current.contains(e.target);
    };
    var handleClickaway = function handleClickaway(event) {
      var shouldFire = false;
      if (Array.isArray(ref)) {
        var results = ref.map(function (r) {
          return containsTarget(event, r);
        });
        if (!results.includes(true)) {
          shouldFire = true;
        }
      } else if (!containsTarget(event, ref)) {
        shouldFire = true;
      }
      if (shouldFire) {
        cb();
      }
    };
    document.addEventListener('mousedown', handleClickaway);
    return function () {
      document.removeEventListener('mousedown', handleClickaway);
    };
  }, []);
};

exports.useClickawayListener = useClickawayListener;
//# sourceMappingURL=useClickawayListener.js.map
